import { FC, useState } from "react"
import { Dialog } from 'primereact/dialog';
import { Button } from "primereact/button";
import './newscenariomodal.css'
import { catchResponse } from "../../../utils/helperFunctions";
import { useHistory, useParams } from "react-router-dom";
import { createNewScenario } from "../../../services/scenario-service";
import { error, success } from "../../../utils/notifications";
import { FiCommand } from "react-icons/fi";
import { TfiSave } from "react-icons/tfi";
import { SelectButton } from "primereact/selectbutton";

export const NewScenarioModal:FC<any> = (props):JSX.Element => {

    const { visible, setVisible, scenarioBase, scenarioBaseName, allScenarios, scenarioPlant } = props

    const {id}:any = useParams()

    const options = ['Si', 'No'];

    const history:any = useHistory()

    const [loadingNewScenario, setLoadingNewScenario] = useState<boolean>(false)

    const [checkOperativo, setCheckOperativo] = useState<string>("No")

    const handleNewScenario = async() => {
        try {
            setLoadingNewScenario(true)
            const res = await createNewScenario(id,checkOperativo === "Si"? true : false)
            if(res.status === 200) {
                const { code, data, message } = res.data
                if(code === 200 && checkOperativo === "No") {
                    success(message)
                    handleCloseModal()
                    setLoadingNewScenario(false)
                    history.push(`/scenario_view/${data.id_new_scenario}/${data.id_new_scenario}`)
                } else {
                    success(message)
                    handleCloseModal()
                    setLoadingNewScenario(false)
                    history.push(`/home`)
                }
                
            } else {
                setLoadingNewScenario(false)
                error("Error creando escenario")
            }
            
        } catch(err:any) {
            setLoadingNewScenario(false)
            catchResponse(err)
        }
    }

    const handleCloseModal = () => {
        setVisible(false)
        setCheckOperativo("No")
    }

   
    return (
        <Dialog header={"Crear nuevo escenario"} headerStyle={{padding:'0.75rem'}} visible={visible} style={{ width: '35vw' }} onHide={handleCloseModal}>
            <div className="new_scenario_container">
                <p className="m-0 new_scenario_text" >
                    Se va a crear un nuevo escenario a partir de los ajustes del escenario base seleccionado : <b><i>{scenarioBase} - {scenarioBaseName}</i></b>.
                </p>
                {
                    !allScenarios[1]?.plants.map((p:any) => p.id_plant).includes(scenarioPlant)?
                    <div>
                        <p className="m-0 new_scenario_text" >
                            Hemos detectado que aún no existe un escenario operativo para esta planta. ¿Te gustaría generar este nuevo escenario como operativo?
                        </p>
                        <SelectButton
                            id="item"
                            name="item"
                            value={checkOperativo}
                            options={options}
                            onChange={(e:any) => setCheckOperativo(e.value)}
                            disabled={loadingNewScenario}
                        />
                    </div>
                        
                    :
                    false
                }
                <p className="m-0 new_scenario_text" >
                    ¿Estás seguro de querer continuar?
                </p>
                

                
                
            </div>
            
            <div className="scenarios-footer pb-1">
                <Button severity={'success'} style={{minWidth:220}} disabled={loadingNewScenario} label={loadingNewScenario? "Generando escenario" : "Crear escenario"} icon={loadingNewScenario? <FiCommand className="loading-icon" style={{fontSize:18,marginRight:'1rem',color:'#22C55E'}} /> :<TfiSave style={{fontSize:18,marginRight:'1rem'}} />}  onClick={handleNewScenario}  outlined />
                <Button severity={'danger'} style={{minWidth:220}} disabled={loadingNewScenario} label="Cancelar" icon="pi pi-times"  outlined  onClick={handleCloseModal} />

            </div>
        </Dialog>
    )
}